/* eslint-disable prettier/prettier */
import { memo, useContext } from 'react';

import { Image } from '@/shared/ui';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { Button } from '../../Button';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './ServerErrorAlert.scss';

export const ServerErrorAlert = memo(function ServerErrorAlert() {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.blue}>
      <div className="server-alert">
        <div className="server-alert__img">
          <Image src="/images/user-question.svg" alt="no data icon" />
        </div>
        <div className="server-alert__title">Сервіс наразі недоступний</div>
        <div className="server-alert__text">Cпробуйте, будь ласка, пізніше</div>
        <div className="server-alert__buttons-box">
          <Button outline onClick={(): void => toggleModal(false)}>
            Закрити
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
